import { render } from "./DependentStep2.vue?vue&type=template&id=6a67fee5&ts=true"
import script from "./DependentStep2.vue?vue&type=script&lang=ts"
export * from "./DependentStep2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__